import { render } from "./ClientLogo.vue?vue&type=template&id=41843174&scoped=true&ts=true"
import script from "./client-logo.component.ts?vue&type=script&lang=ts&external"
export * from "./client-logo.component.ts?vue&type=script&lang=ts&external"

import "./client-logo.scss?vue&type=style&index=0&id=41843174&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41843174"]])

export default __exports__